import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import getGameId from '@/utils/getGameId';
import {fetchWithRetry} from '@/utils/fetchWithRetry';

export default async function createAnonProfile() {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  const gid = getGameId();

  return fetchWithRetry('/api/create-anon-profile', {
    method: 'POST',
    headers,
    body: JSON.stringify({gid}),
  });
}
